import { AfterViewInit, Component, Input } from '@angular/core';
import _ from 'lodash';
import { BxUnverifiedAlertService } from '../../../core/services/bx-unverified-alert.service';
import { PermissionService } from '../../../core/services/permission';
import { RepoRemindersService } from '../../../data/repositories/repo-reminders.service';
import { RepoSettingsService } from '../../../data/repositories/repo-settings.service';
import { SharedDataService } from '../../../data/services/shared-data.service';
import { TimelineMonth } from '../../contacts/ui-components/ui-reminders-timeline/timeline-month.model';
import { RemindersService } from '../../dashboard/reminders.service';
import { ClientsService } from '../clients.service';

@Component({
    selector: 'app-client-reminder-timeline',
    templateUrl: './client-reminder-timeline.component.html',
    styleUrls: ['./client-reminder-timeline.component.scss'],
    standalone: false,
})
export class ClientReminderTimelineComponent implements AfterViewInit {
    @Input() customer: any;
    months: TimelineMonth[] = [];
    moreActions = [
        {
            groupName: 'Display Only',
            actions: [
                { label: 'Show all items', condition: true, value: true },
                { label: 'Hide completed items', condition: true, value: false },
            ],
        },
    ];

    constructor(
        private bxUnverifiedAlertService: BxUnverifiedAlertService,
        private clientsService: ClientsService,
        public settings: RepoSettingsService,
        private remindersRepo: RepoRemindersService,
        private sharedData: SharedDataService,
        private remindersService: RemindersService,
        public permissionService: PermissionService
    ) {}

    ngAfterViewInit(): void {
        this.load();
    }

    load() {
        const config: any = {};

        if (this.settings.CustomersExcludeCompletedReminders) {
            config.excludeCompleted = true;
        }
        this.remindersRepo.GetByReference(this.customer?.ID_Customer, config).then((data) => {
            this.months.length = 0;
            const sorted = _.sortBy(data.results, ['FirstOfMonth', 'DueDate']);
            const groups = _.groupBy(sorted, (value) => {
                return value.FirstOfMonth.toISOString();
            });
            for (const property in groups) {
                if (Object.prototype.hasOwnProperty.call(groups, property)) {
                    this.months.push({
                        month: property,
                        monthDate: new Date(property),
                        // @ts-ignore TS2322
                        items: groups[property],
                    });
                }
            }
        });
    }

    addReminder() {
        if (!this.sharedData.UserData.identityInfo.email_verified) {
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }
        this.clientsService
            .newReminder(this.customer.ID_Customer)
            .then(() => {
                this.load();
            })
            .catch(() => {});
    }

    // @ts-ignore TS7006
    viewReminder(reminder) {
        this.remindersService
            .viewReminder(reminder)
            .then(() => {
                this.load();
            })
            .catch(() => {});
    }

    // @ts-ignore TS7006
    saveReminder(reminder) {
        this.remindersRepo.Save(reminder, 'Reminder saved');
    }

    resolveSettingsAction(val: boolean) {
        this.settings.CustomersExcludeCompletedReminders = !val;
        this.load();
    }

    // @ts-ignore TS7006
    deleteReminder(reminder) {
        reminder.IsDeleted = true;
        const msg = 'Reminder deleted';
        this.remindersRepo.Save(reminder, msg);
        this.removeSelectedReminderFromList(reminder);
    }

    // @ts-ignore TS7006
    private removeSelectedReminderFromList(reminder) {
        this.months.forEach((month) => {
            if (month != null && month.items != null) {
                month.items.forEach((item) => {
                    if (item.ID_Reminder == reminder.ID_Reminder) {
                        const index = month.items.indexOf(reminder);
                        month.items.splice(index, 1);
                        return;
                    }
                });
            }
        });
    }
}
